//接口地址

const apiPrefix = 'http://39.101.74.19:8717/base-admin';

const apiPrefixGG = 'http://39.101.74.19:8088/base-admin';


import https from './https';
// home接口
function banners(params) {
    return https.get(apiPrefix + '/zm/front/banners', params);
}
// 首页新
function getnewindex(ascription, page, limit) {
    return https.get(apiPrefix + `/zm/front/resource?ascription=${ascription}&page=${page}&limit=${limit}`);
}
// 网站底部-友情链接
function getfriendship(status) {
    return https.get(apiPrefix + `/zm/front/friendShip/${status}`);
}
// 新闻中心-新
function getnewNews(newsType, page, limit) {
    return https.get(apiPrefix + `/zm/front/companyNews?newsType=${newsType}&page=${page}&limit=${limit}`);
}
// 网站底部-公司信息
function getmsg(params) {
    return https.get(apiPrefix + '/zm/front/companyInfo', params);
}
//标签名称
function gettagName(params) {
    return https.get(apiPrefix + '/zm/front/tagName', params);
}
//标签的项目案例
function gettabdetail(tagId, page, limit) {
    return https.get(apiPrefix + `/zm/front/queryByTagId?tagId=${tagId}&page=${page}&limit=${limit}`);
}
//商务合作
function businessWork(params) {
    return https.get(apiPrefix + '/zm/front/businessWork', params);
}

//招贤纳才
function inviteInfo(page, limit) {
    return https.get(apiPrefix + `/zm/front/inviteInfo?page=${page}&limit=${limit}`);
}
//建筑工程封面
function Project(params) {
    return https.get(apiPrefix + '/zm/front/constructionProjectCover', params);
}
// 资源详情
function getdetails(id) {
    return https.get(apiPrefix + `/zm/front/resourceDetail/${id}`);
}
// 招聘信息详情 GET /zm/front/invite/{id}
function getdetailsTwo(id) {
    return https.get(apiPrefix + `/zm/front/invite/${id}`);
}
// 新闻详情 GET /zm/front/newsCenter/{id}
function getNewdetails(id) {
    return https.get(apiPrefix + `/zm/front/newsCenter/${id}`);
}


// 集团高管
function getnewGGperson(ascription, page, limit) {
    return https.get(apiPrefixGG + `/${ascription}?page=${page}&limit=${limit}`);
}


// // 首页
// function getindex(params) {
//     return https.get(apiPrefix + '/zm/front/firstPage', params);
// }
// //首页关于中明
// function getindexabout(params) {
//     return https.get(apiPrefix + '/zm/front/firstPageAboutZm', params);
// }
// // 首页_业务范围
// function getindexBusinessRange(params) {
//     return https.get(apiPrefix + '/zm/front/firstPageBusinessRange', params);
// }
// // 首页_精品工程
// function getindexExcellentProjecct(params) {
//     return https.get(apiPrefix + '/zm/front/firstPageExcellentProjecct', params);
// }
// // 关于中明
// function about(params) {
//     return https.get(apiPrefix + '/zm/front/about', params);
// }
// // 新闻中心
// function getnews(params) {
//     return https.get(apiPrefix + '/zm/front/newsDetail}', params);
// }
// // 新闻中心2
// function getnew(params) {
//     return https.get(apiPrefix + '/zm/front/news', params);
// }
// // 新闻动态信息
// function getGroupDynamic(params) {
//     return https.get(apiPrefix + '/zm/front/groupDynamic', params);
// }
// // 产品与服务
// function getser(params) {
//     return https.get(apiPrefix + '/zm/front/services', params);
// }
// // 党群工作
// function getparty(params) {
//     return https.get(apiPrefix + '/zm/front/party', params);
// }
// // 党群工作详情
// function goPartyDetail(id) {
//     return https.get(apiPrefix + `/zm/front/party${id}`);
// }
// // 人才发展大图
// function getcontact(params) {
//     return https.get(apiPrefix + '/zm/front/contact', params);
// }
// // 人才发板块
// function getdevelop(params) {
//     return https.get(apiPrefix + '/zm/front/develop', params);
// }
// // 人才发招聘
// function getinvite(params) {
//     return https.get(apiPrefix + '/zm/front/invite', params);
// }
// //人才招聘详情
// function goInvite(id) {
//     return https.get(apiPrefix + `/zm/front/invite/${id}`);
// }
// // //新闻中心
// // function getnewsR(params, pageNo, pageSize) {
// //     return https.get(apiPrefix + `/zm/front/groupDynamic?newsType=${params}&currPageNo=${pageNo}&limitNo=${pageSize}`);
// // }
// //新闻中心
// function getnewsR(newsType, currPageNo, limitNo) {
//     return https.get(
//         apiPrefix + `/zm/front/groupDynamic?newsType=${newsType}&currPageNo=${currPageNo}&limitNo=${limitNo}`,
//     );
// }
// // 详情
// function getdetails(params) {
//     return https.get(apiPrefix + `/zm/front/Detail/${params}`);
// }
// // 详情Read More
// function goNewsDetails(id) {
//     return https.get(apiPrefix + `/zm/front/newsDetail/${id}`);
// }
// //服务领域
// function servicearea(params) {
//     return https.get(apiPrefix + '/zm/front/services', params);
// }
// //服务领域建筑工程钢结构.
// function tabsdetail(tagId) {
//     return https.get(apiPrefix + '/zm/front/queryByTagId', { tagId });
// }
// //服务领域——建筑工程
// function serviceproject(params) {
//     return https.get(apiPrefix + '/zm/front/tagName', params);
// }
// //规划设计
// function design(params) {
//     return https.get(apiPrefix + '/zm/front/services/planDesign', params);
// }
// //服务领域规划设计项目案列
// function designcase(params) {
//     return https.get(apiPrefix + '/zm/front/services/projectCase', params);
// }
// //EPC一级页面
// function EPCcase(params) {
//     return https.get(apiPrefix + '/zm/front/services/epcProjectCase', params);
// }
// //EPC案例
// function EPCexample(params) {
//     return https.get(apiPrefix + '/zm/front/services/epcProjectCaseExample', params);
// }
// //工程监理
// function projectSupervision(params) {
//     return https.get(apiPrefix + '/zm/front/services/projectSupervision', params);
// }
// //工程监理项目案例
// function projectSupervisionCase(params) {
//     return https.get(apiPrefix + '/zm/front/services/projectSupervisionCase', params);
// }
export {
    inviteInfo,
    businessWork,
    gettabdetail,
    gettagName,
    projectSupervisionCase,
    projectSupervision,
    EPCcase,
    tabsdetail,
    EPCexample,
    designcase,
    serviceproject,
    design,
    banners,
    about,
    getindex,
    getnews,
    getnewsR,
    getparty,
    getcontact,
    getdevelop,
    getinvite,
    getser,
    getdetails,
    goNewsDetails,
    goInvite,
    goPartyDetail,
    getboutique,
    getindexabout,
    servicearea,
    getindexBusinessRange,
    getnew,
    getGroupDynamic,
    getindexExcellentProjecct,
    getnewindex,
    getfriendship,
    getmsg,
    getnewNews,
    getdetailsTwo,
    getNewdetails,
    Project,

    getnewGGperson
};



// WEBPACK FOOTER //
// ./src/api/api.js